type ConditionalWrapperProps = {
  condition: boolean
  wrapper1: (children: React.ReactNode) => JSX.Element
  wrapper2: (children: React.ReactNode) => JSX.Element
}

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
  condition,
  wrapper1,
  wrapper2,
  children,
}): JSX.Element => (condition ? wrapper1(children) : wrapper2(children))

export default ConditionalWrapper

export function cancelFullscreen(): void {
  const document: any = window.document
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen()
  }
}
export function checkIfFullscreen(): boolean {
  const document: any = window.document

  if (
    document.fullscreenElement ||
    document.msFullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement
  ) {
    return true
  }

  return false
}
